import Vue from 'vue' 
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy';
import VueSweetalert2 from 'vue-sweetalert2';
import VTooltip from 'v-tooltip'  
import store from '@/state/store'
import App from './App.vue'  
import i18n from './helpers/i18n'
import tinymce from 'vue-tinymce-editor'
import axios from 'axios'
import { BootstrapVue, IconsPlugin,ToastPlugin,BToast } from 'bootstrap-vue'  
import VSwitch from 'v-switch-case' 
import VueExcelEditor from 'vue-excel-editor'
import Toast from "vue-toastification";
import VueSession from "vue-session";
import VueCookies from 'vue-cookies'
import VueCryptojs from 'vue-cryptojs'
import VueCookiesreactive from 'vue-cookies-reactive'
Vue.use(VueCookiesreactive)

var VueCookie = require('vue-cookie'); 
Vue.use(VueCookie);

Vue.use(VueCryptojs)
Vue.use(VueCookies)

Vue.config.productionTip = false;


import "vue-toastification/dist/index.css";  
import "../src/design/app.scss"; 
  
fetch(window.location.protocol+"//"+window.location.host+"/assets/config.json")
.then(response => response.json())
.then(config => {  
Vue.prototype.$config = config    
axios.defaults.baseURL = config.API_URL
axios.defaults.headers.common = { 'Authorization': 'Bearer '+store.getters["auth/JWToken"] }

var options = {
  persist: true
}

Vue.use(VueSession, options)
 
Vue.use(VTooltip)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)
Vue.component('b-toast', BToast)
  
Vue.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});
 

Vue.use(VueExcelEditor)


Vue.use(VSwitch)
 
 

Vue.component('tinymce', tinymce)
Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

//Vue.use(BootstrapVue)

Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
}) 